module.exports = __webpack_public_path__ + "static/media/navBar-arrow.34fbad56.svg";